import { Grid, Tab, Tabs, styled } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "routes/paths";
import { useSelector } from "react-redux";

function WalletTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user?.user?.data);

  const handleChangeTab = (_, newValue) => {
    navigate(newValue);
  };
  return (
    <Grid item xs={12}>
      <TabsStyle value={location.pathname} onChange={handleChangeTab}>
        <Tab value={"/wallet/spot"} label={"Spot"} />
        <Tab value={"/wallet/margin"} label={"Margin"} />
        {
          user?.isHaveViewInvestment &&
          <Tab value={ROUTE_PATHS.wallet.investment} label={"Investment fund"} />
        }
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
  width: "100%",

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default WalletTabs;
